export enum StatusQueueEnum{
    nao_atendido = 1,
    evadido = 2,
    atendido = 4,
    chamando = 5,
    em_atendimento = 6,
    retorno = 7,
}